import { DiagnosisItem } from "../../diagnosis.model";
import { Tooth } from "../../../../odontogram/odontogram.model";
import { ItemValidators } from "../../../item-validators";
import { AbstractCondition } from "../condition";

export class Bridge extends AbstractCondition {
  static validate(
    item: DiagnosisItem,
    odontogram: Tooth[],
    items: DiagnosisItem[],
  ): boolean {
    // validate teeth selected
    if (!ItemValidators.hasTeethSelected(item, 2)) {
      return false;
    }

    // validate same jaw
    if (!ItemValidators.sameJaw(item)) {
      // TODO: display error
      return false;
    }

    // validate bridge option
    if (!ItemValidators.hasOptionSelected(item)) {
      return false;
    }

    return true;
  }

  static apply(odontogram: Tooth[], item: DiagnosisItem): Tooth[] {
    const option = item.options.options.join(" ");

    const mesialTeeth = [];
    const distalTeeth = [];

    let upperArch = Array.apply(null, Array(16));
    upperArch = upperArch.map((val, i) => {
      const number = i < 8 ? 18 - i : i + 13;
      return {
        number: number,
        applied: item.teeth.includes(number),
      };
    });

    let lowerArch = Array.apply(null, Array(16));
    lowerArch = lowerArch.map((val, i) => {
      const number = i < 8 ? 48 - i : i + 23;
      return {
        number: number,
        applied: item.teeth.includes(number),
      };
    });

    upperArch.forEach((tooth, i) => {
      if (tooth.applied) {
        if (i > 0 && upperArch[i - 1].applied) {
          if (i <= 7) {
            distalTeeth.push(tooth.number);
          } else {
            mesialTeeth.push(tooth.number);
          }
        }
        if (i < 15 && upperArch[i + 1].applied) {
          if (i <= 7) {
            mesialTeeth.push(tooth.number);
          } else {
            distalTeeth.push(tooth.number);
          }
        }
      }
    });

    lowerArch.forEach((tooth, i) => {
      if (tooth.applied) {
        if (i > 0 && lowerArch[i - 1].applied) {
          if (i <= 7) {
            distalTeeth.push(tooth.number);
          } else {
            mesialTeeth.push(tooth.number);
          }
        }
        if (i < 15 && lowerArch[i + 1].applied) {
          if (i <= 7) {
            mesialTeeth.push(tooth.number);
          } else {
            distalTeeth.push(tooth.number);
          }
        }
      }
    });

    odontogram
      .filter((tooth) => item.teeth.indexOf(tooth.number) > -1)
      .forEach((tooth, i) => {
        tooth.diagnosis.push({ condition: item.condition, options: option });
        if (mesialTeeth.includes(tooth.number)) {
          tooth.diagnosis.push({
            condition: item.condition,
            options: `mesial ${option}`,
          });
        }
        if (distalTeeth.includes(tooth.number)) {
          tooth.diagnosis.push({
            condition: item.condition,
            options: `distal ${option}`,
          });
        }
      });

    return odontogram;
  }

  static getDescriptionIdentifiers(item: DiagnosisItem): string[] {
    return item.options.options.map((option) => `bridge_${option}`);
  }

  static getDiagnosis360Changes(item: DiagnosisItem): any {
    const update = {};

    if (item.options.options.includes("discolored")) {
      update["darkening"] = true;
    }

    if (!item.options.options.includes("ok")) {
      update["problems_existing_treatments"] = true;
    }

    return Object.keys(update).length > 0 ? update : null;
  }

  static supports(condition: string): boolean {
    return condition === "bridge";
  }

  static getItemResume(item: DiagnosisItem): any {
    return [
      {
        name: "status",
        value: item.options.options.map(
          (option) => "diagnosis.options." + option,
        ),
      },
    ];
  }

  static getTableData(item: DiagnosisItem): any {
    return [
      "",
      item.options.options.map((option) => "diagnosis.options." + option),
    ];
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/diagnosis/conditions/prostho/bridge.ts